import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as rccActions from "../../../actions/rccActions";

import Button from "../generic/Button";

class SpectroConnectButton extends Component {
    handleStartConnectClick = () => {
        if (this.props.spectro.isSelected && !this.props.spectro.isConnected) {
            this.props.dispatchConnectSpectroAction();
        }
    };

    render() {
        if (!this.props.connected || !this.props.spectro.isSelected || this.props.spectro.isConnected) {
            return "";
        }

        return (
            <Button
                label={<Translate value="spectroTab.connectDevice" />}
                onClick={this.handleStartConnectClick}
                disabled={this.props.spectro.dialog !== null}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        connected: store.rcc.connected,
        spectro: store.spectro.spectro
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchConnectSpectroAction: () => {
            dispatch(rccActions.connectSpectro());
        }
    };
};

export default SpectroConnectButton = connect(mapStoreToProps, mapDispatchToProps)(SpectroConnectButton);
